import React, { Component } from 'react';
import PropTypes from 'prop-types';
import List from './List';

class SecondaryFilter extends Component {
  static propTypes = {
    filterData: PropTypes.object,
    FilterDataObj: PropTypes.object,
    categoryActions: PropTypes.any,
  };
  constructor(props, context) {
    super(props, context);
    this.state = {
      childChecker: false,
    };
  }

  render() {
    const {
      filterData,
      categoryActions,
      FilterDataObj,
      modifySelectedFilterList,
      currentFilterData,
      filterDrop,
      userFrameSize,
      dataLocale,
    } = this.props;
    const openDiv = currentFilterData.id === filterDrop;
    const showUL = currentFilterData.id === filterDrop;
    return (
      <div className="dropdown second-filter-dropdown">
        <div
          aria-expanded="true"
          aria-haspopup="true"
          className={openDiv ? 'white-bg btn btn dropdown-toggle ' : 'btn dropdown-toggle'}
          data-toggle="dropdown"
          type="button"
          onClick={() => {
            categoryActions.filterDropdown(
              currentFilterData.id !== filterDrop ? filterData.id : false
            );
          }}
        >
          {filterData.name.toUpperCase()}
        </div>
        {showUL ? (
          <ul
            key={Date.now()}
            className="filter-dropdown-menu list-unstyled not-click-container menu-lk "
          >
            {filterData.options.map((data, keys) => {
              let checkedOptions = FilterDataObj[filterData.id];
              if (checkedOptions === [] || typeof checkedOptions === 'undefined') {
                checkedOptions = [];
              }
              this.state.childChecker = false;
              checkedOptions.forEach(key => {
                if (key.childid === data.id) {
                  this.state.childChecker = true;
                }
              });
              return (
                <List
                  key={keys}
                  checkedOptions={this.state.childChecker}
                  count={data.no_of_products}
                  data={data}
                  dataLocale={dataLocale}
                  filterList={filterData.id}
                  handleFunc={(childname, childid) =>
                    modifySelectedFilterList(childname, childid, currentFilterData)
                  }
                  isPrimaryFilter="false"
                  userFrameSize={userFrameSize}
                />
              );
            })}
          </ul>
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default SecondaryFilter;
